import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  showWarningMessage,
  showErrorMessage,
  API_URL,
};
export const GET_DOCUMENTTYPES = `${API_URL}/MasterDocumentTypes/GetDocumentTypes`;
export const POST_DOCUMENTTYPES = `${API_URL}/MasterDocumentTypes/SaveDocumentTypes`;
export const GET_DOCUMENTTYPES_BY_ID = `${API_URL}/MasterDocumentTypes/GetDocumentTypesById`;
export const DELETE_DOCUMENTTYPES = `${API_URL}/MasterDocumentTypes/DeleteDocumentTypes`;

export const documentTypeActionTypes = {
  get_documenttype: createRequestActionTypes('GET_DOCUMENTTYPES'),
  post_documenttype: createRequestActionTypes('POST_DOCUMENTTYPES'),
  get_documenttype_by_id: createRequestActionTypes('GET_DOCUMENTTYPES_BY_ID'),
  delete_documenttype: createRequestActionTypes('DELETE_DOCUMENTTYPES'),
};
export const MODULE = 'MASTER_DOCUMENTTYPES';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypes/constants/ApiConstants.js